module.exports = {"450205001":"解放街道","450205002":"雅儒街道","450205003":"胜利街道","450205004":"雀儿山街道","450205005":"钢城街道","450205006":"锦绣街道","450205007":"白露街道","450205100":"石碑坪镇","450205101":"沙塘镇","450205102":"长塘镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450205.json
// module id = 1910
// module chunks = 0